import { render, staticRenderFns } from "./infoUser.vue?vue&type=template&id=b0a49670&"
import script from "./infoUser.vue?vue&type=script&lang=js&"
export * from "./infoUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports